// extracted by mini-css-extract-plugin
module.exports = {"login":"login--3P8LgJ350","form_wrap":"form_wrap--_NUkT0lzd"};